import React from "react";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import swal from "sweetalert";
import { useEffect } from "react";
import { makePostRequest } from "../../../utils/utils";
// import * as Yup from "yup";
// import { Formik, Form } from "formik";
import LockOpenIcon from "@mui/icons-material/LockOpen";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import IconButton from "@mui/material/IconButton";
// import FilledInput from "@mui/material/FilledInput";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
// import FormHelperText from "@mui/material/FormHelperText";
// import FormControl from "@mui/material/FormControl";
// import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

//Validations For Resident Details
// const Validation_Schema = Yup.object().shape({
//   newPassword: Yup.string()
//     .required("Required")
//     .matches(
//       /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
//       "Numbers not allowed!!"
//     ),
//   lastname: Yup.string()
//     .required("Required")
//     .matches(
//       /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
//       "Numbers not allowed!!"
//     ),
// });

// var formikInitials = {
//   newPassword: "",
//   confirmPassword: "",
// };

// function showPassword(isConfirmPassword) {
//   if (isConfirmPassword) {
//     var confirmPasswordEle = document.getElementById("confirmPassword");
//     if (confirmPasswordEle.type === "password") {
//       confirmPasswordEle.type = "text";
//     } else {
//       confirmPasswordEle.type = "password";
//     }
//   } else {
//     var passwordEle = document.getElementById("passwordId");
//     if (passwordEle.type === "password") {
//       passwordEle.type = "text";
//     } else {
//       passwordEle.type = "password";
//     }
//   }
// }

function ChangePassword() {
  const navigate = useNavigate();
  // For Eye
  const [showPassword, setShowPassword] = React.useState(false);
  // For Eye 2
  const [showPassword2, setShowPassword2] = React.useState(false);

   
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [errorMsg, setErrorMessage] = React.useState("");
  const [confirmErrorMsg, setConfirmErrorMessage] = React.useState("");
  const [successMsg] = React.useState("");

  
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // End

  

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };
  // End

 

  async function handleChangeConfirmPassword(newValue) {
    if (newPassword !== newValue) {
      // setSuccessMessage("");
      setConfirmErrorMessage("Password Not Matched");
      setConfirmPassword(newValue);
    } else {
      // setSuccessMessage("Password Verified");
      setConfirmErrorMessage("");
      setConfirmPassword(newValue);
      document.getElementById("submitPassword").disabled = false;
    }
  }

  async function validatePassword(password) {
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    // var specialChar = /[!@#\$%\^\&\b*\)\(+=._-]/g;
    var specialChar = /[!@#$%^&*()+=._-]/g;

    if (!password.match(lowerCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(upperCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(numbers)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(specialChar)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (password.length < 8) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else {
      setErrorMessage("");
      setNewPassword(password);
      document.getElementById("confirmPassword").disabled = false;
    }
  }

  async function changePassword() {
    var inputdata = {
      email_id: localStorage.getItem("forgetEmail"),
      reset_pass_code: localStorage.getItem("verificationCode"),
      password: newPassword,
      isemailverify: true,
    };
    await makePostRequest("resident/resetPasswordWeb", inputdata)
      .then(async (response) => {
        console.log(response);
        if (response.data.data !== undefined) {
          console.log(response);
          swal("Password Changed Successfully", "Login With New Password", "success",{
            timer: 3000,
            buttons: false,
          });
          localStorage.removeItem("forgetEmail");
          localStorage.removeItem("verificationCode");
          
          navigate("/");
        }
      })
      .catch((err) => {
        swal(
          "Incorrect Code !!",
          "Verification code doesen't match",
          "warning"
        );
      });
  }

  useEffect(() => {
    document.getElementById("confirmPassword").disabled = true;
    document.getElementById("submitPassword").disabled = true;
  }, []);
  return (
    <>
      <div className="loginwrapper">
        <div className="loginLeft" id="logAndForgot">
          <div className="loginBox" id="">
            <h2>ResiPro</h2>
            <div className="loginInner">
              <div className="bottSection">
                <h3>Change Your Password</h3>
                <h5 className="requiPassTex">
                  (Use a combination of uppercase letters, lowercase letters,
                  numbers, and symbols)
                </h5>
                <div className="passwordOut">
                  <Input
                    placeholder="Enter New Password"
                    className="myInput"
                    id="passwordId"
                    value={newPassword}
                    onChange={(e) => validatePassword(e.target.value)}
                    type={showPassword ? "text" : "password"}
                    startAdornment={
                      <InputAdornment position="start">
                        <LockOpenIcon />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {/* <div className="passwordshowIcon">
                    <RemoveRedEyeIcon onClick={() => showPassword(false)} />
                  </div> */}
                </div>
                <span className="wrongPassError">{errorMsg}</span>

                <div className="passwordOut">
                  <Input
                    placeholder="Confirm Password"
                    className="myInput"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) =>
                      handleChangeConfirmPassword(e.target.value)
                    }
                    type={showPassword2 ? "text" : "password"}
                    startAdornment={
                      <InputAdornment position="start">
                        <LockOpenIcon />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                          edge="end"
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {/* <div className="passwordshowIcon">
                    <RemoveRedEyeIcon onClick={() => showPassword(true)} />
                  </div> */}
                </div>
                {successMsg == "Password Verified.." ? (
                  <span className="wrongPassError successMsg">
                    {successMsg}
                  </span>
                ) : (
                  <span className="wrongPassError">{confirmErrorMsg}</span>
                )}

                <Button
                  id="submitPassword"
                  variant="contained"
                  className="logButton"
                  onClick={() => changePassword()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
